// Admin auth helper — Bearer JWT stored in localStorage.

const BASE = process.env.REACT_APP_BACKEND_URL;
const KEY = 'russian_edu_admin_token';

export function getToken() {
  return localStorage.getItem(KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(KEY, token);
  else localStorage.removeItem(KEY);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

async function _req(path, opts = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = res.status === 401 ? 'Unauthorized' : 'Request failed';
    try {
      const b = await res.json();
      if (b?.detail) detail = typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail);
    } catch (_) { /* ignore */ }
    // Clear stored token on 401 so guarded pages redirect to login
    if (res.status === 401 && token) clearToken();
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function adminLogin(email, password) {
  const data = await _req('/api/admin/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  setToken(data.access_token);
  return data.admin;
}

export async function adminMe() {
  return _req('/api/admin/me');
}

export async function adminStats() {
  return _req('/api/admin/stats');
}

export async function adminInquiries({ type, limit = 200, skip = 0 } = {}) {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  params.set('limit', String(limit));
  params.set('skip', String(skip));
  return _req(`/api/admin/inquiries?${params.toString()}`);
}
